import Studio from '../studio';    
import Orcamento from '../orcamento';
import Footer from '../footer';
import Home from '../Home';
import Artista from '../artista';
import Feedbacks from '../feedbacks';
import Galeria from '../galeria'

export default function LandingPage(){
    return(
        <div>
            <Home />
            <Galeria/>
            <Artista />
            <Feedbacks/>
            <Studio />
            <Orcamento />
            <Footer />
        </div>
    )
}